import * as React from 'react';

import type {CoreEntityType} from 'nutshell-core/types';

import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';

import {NavItemWrapper} from './nav-item/nav-item-wrapper';
import type {NavItemObj, SidebarSectionType} from './types';

type Props = {
    entityType: CoreEntityType;
    type: SidebarSectionType;
    navItems: NavItemObj[];
    listsAreImmutable: boolean;
    searchNameQuery: string | null | undefined;
    onOpenModal: (navItem: NavItemObj, isImmutable: boolean) => void;
    onClosePopover: () => void;
    onShare?: (navItem: NavItemObj) => void;
};

export function VisibleNavItems(props: Props) {
    const infoText = getInfoText(
        props.type,
        Boolean(props.searchNameQuery && props.searchNameQuery.length)
    );

    return (
        <>
            {props.navItems.length > 0 ? (
                <>
                    {props.navItems.map((navItem) => {
                        return (
                            <NavItemWrapper
                                key={`${props.type}-${navItem.id || navItem.name}`}
                                entityType={props.entityType}
                                type={props.type}
                                navItem={navItem}
                                onEdit={() => props.onOpenModal(navItem, props.listsAreImmutable)}
                                onClick={props.onClosePopover}
                                searchNameQuery={props.searchNameQuery}
                                onShare={props.onShare}
                            />
                        );
                    })}
                </>
            ) : (
                infoText && <div className='pad-8'>{infoText}</div>
            )}
        </>
    );
}

function getInfoText(
    type: SidebarSectionType,
    isSearching: boolean
): React.ReactNode | null | undefined {
    if (isSearching) {
        return (
            <Body size='tiny' color='placeholder'>
                {type === 'audiences' ? 'No audiences found' : 'Nothing found'}
            </Body>
        );
    }

    if (type === 'saved') {
        return (
            <>
                <Body size='tiny' color='placeholder'>
                    You haven’t saved any lists.
                </Body>
            </>
        );
    }

    if (type === 'audiences') {
        return (
            <>
                <Body size='tiny' color='placeholder'>
                    Create an audience to define a list of contacts for campaigns.
                </Body>{' '}
                <Link
                    href='https://support.nutshell.com/en/articles/8428866-audiences-how-to-create-marketing-audiences'
                    size='tiny'
                    variant='primary'
                    newTab={true}
                >
                    Learn more
                </Link>
            </>
        );
    }
}
